import { useServiceWorkerUpdate } from '../../hooks/useServiceWorkerUpdate';
import React, { useState, useEffect } from 'react';

const UpdateNotification = () => {
  const { showPrompt, isUpdating, triggerUpdate, dismissPrompt } = useServiceWorkerUpdate();
  const [isVisible, setIsVisible] = useState(false);
  const [startY, setStartY] = useState(null);

  useEffect(() => {
    if (showPrompt) {
      setTimeout(() => setIsVisible(true), 100);
    } else {
      setIsVisible(false);
    }
  }, [showPrompt]);

  const handleTouchStart = (e) => {
    setStartY(e.touches[0].clientY);
  };

  const handleTouchEnd = (e) => {
    if (!startY) return;
    const endY = e.changedTouches[0].clientY;
    const deltaY = startY - endY;
    
    if (deltaY > 50) {
      dismissPrompt();
    }
    setStartY(null);
  };

  const handleUpdate = async () => {
    try {
      if (navigator.vibrate) {
        navigator.vibrate([50, 30, 50]);
      }
      await triggerUpdate();
    } catch (error) {
      console.error('Update failed:', error);
    }
  };

  if (!showPrompt) return null;

  return (
    <>
      <div 
        className={`fixed inset-0 bg-black/20 backdrop-blur-sm z-[9998] transition-opacity duration-300 ${
          isVisible ? 'opacity-100' : 'opacity-0'
        }`}
        onClick={dismissPrompt}
      />
      
      <div 
        className={`fixed bottom-0 left-0 right-0 z-[9999] transition-all duration-500 ease-out ${
          isVisible ? 'translate-y-0' : 'translate-y-full'
        }`}
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}
      >
        <div className="mx-2 mb-6 flex justify-center">
          <div className="bg-gradient-to-r from-blue-600 to-blue-500 text-white rounded-2xl shadow-2xl overflow-hidden max-w-md w-full">
            <div className="px-6 py-5">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-white/15 rounded-2xl flex items-center justify-center flex-shrink-0 mt-1">
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                  </svg>
                </div>
                
                <div className="flex-1 min-w-0">
                  <h3 className="text-lg font-semibold text-white leading-tight mb-1">
                    App Update Available
                  </h3>
                  <p className="text-white/90 text-sm leading-relaxed">
                    Get the latest features and improvements with one tap
                  </p>
                  
                  <div className="flex items-center gap-3 mt-4">
                    <button
                      onClick={handleUpdate}
                      disabled={isUpdating}
                      className={`h-12 px-3 font-semibold text-sm rounded-xl transition-all duration-200 active:scale-95 border-2 ${
                        isUpdating 
                          ? 'bg-white/10 text-white/60 border-white/20 cursor-not-allowed' 
                          : 'bg-white/20 text-white hover:bg-white/30 hover:text-white border-white/30 hover:border-white/40'
                      }`}
                    >
                      {isUpdating ? (
                        <div className="flex items-center gap-2">
                          <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                          <span>Updating...</span>
                        </div>
                      ) : (
                        <div className="flex items-center gap-2">
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                          </svg>
                          <span>Update Now</span>
                        </div>
                      )}
                    </button>
                    
                    <button
                      onClick={dismissPrompt}
                      disabled={isUpdating}
                      className="h-12 px-4 text-white/90 hover:text-white hover:bg-white/10 rounded-xl transition-all duration-200 active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed font-medium text-sm border-2 border-white/20 hover:border-white/30"
                    >
                      Later
                    </button>
                  </div>
                </div>
                
                <button
                  onClick={dismissPrompt}
                  disabled={isUpdating}
                  className="w-10 h-10 rounded-xl hover:bg-white/10 flex items-center justify-center transition-all duration-200 active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed flex-shrink-0"
                  aria-label="Close notification"
                >
                  <svg className="w-5 h-5 text-white/70" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
            </div>
            
            <div className="px-6 pb-3">
              <div className="flex items-center justify-center mb-2">
                <div className="w-12 h-1 bg-white/20 rounded-full" />
              </div>
              <p className="text-white/60 text-xs text-center">
                Swipe up to dismiss
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export { UpdateNotification };
export default UpdateNotification;